import type { Reducer } from "@reduxjs/toolkit"

import { Platform } from "react-native"

import {
  loadActiveUserAsync,
  submitAppFeatureFeedbackAsync,
} from "@/base/farmhq-api"
import { createSlice } from "@reduxjs/toolkit"

import { signOutAsync } from "./auth.reducer"

import type { RootState } from "./root.reducer"

interface AppState {
  isAppLiked?: boolean | null
  isShareAvailable?: boolean
  isTimedOut?: boolean
}

const initialState: AppState = {}

const slice = createSlice({
  extraReducers: (builder) => {
    return builder
      .addCase(signOutAsync.fulfilled, (state) => {
        state.isTimedOut = false
      })
      .addCase(submitAppFeatureFeedbackAsync.pending, (state, action) => {
        if (typeof action.meta.arg.isLiked === "boolean") {
          state.isAppLiked = action.meta.arg.isLiked
        }
      })
      .addCase(loadActiveUserAsync.fulfilled, (state, { payload }) => {
        state.isAppLiked = payload.appFeatureFeedback.find(
          (feature) => feature.featureName === "app",
        )?.isLiked
      })
  },
  initialState,
  name: "appState",
  reducers: {
    hideTimedOutScreen: (state) => {
      state.isTimedOut = false
    },
    onShareAvailable: (state) => {
      state.isShareAvailable = true
    },
  },
})

export const { hideTimedOutScreen, onShareAvailable } = slice.actions

const appState: Reducer<typeof initialState> = slice.reducer
export default appState

export function getIsShareAvailable(state: RootState) {
  if (Platform.OS === "web") {
    return state.appState.isShareAvailable === true
  }
  return true
}
